import React, { ReactElement } from "react";
import { Card, Statistic, Row, Col } from "antd";
import { NumberOutlined } from "@ant-design/icons";
import kNumberFormatter from "../../../shared/kNumberFormatter";

type AdTrackerStatisticsProps = {
  adsWtdLoading: boolean;
  adsWtdValue: number;
  adsLwtdLoading: boolean;
  adsLwtdValue: number;
  adsMtdLoading: boolean;
  adsMtdValue: number;
  adsLmtdLoading: boolean;
  adsLmtdValue: number;
  adsWtdTitle: string;
  adsLwtdTitle: string;
  adsMtdTitle: string;
  adsLmtdTitle: string;
};

type StatisticCardProps = {
  loading: boolean;
  title: string;
  value: number;
}

const StatisticCard = ({ title, loading, value }: StatisticCardProps) => 
  <Card>
    <Statistic
      title={title}
      value={kNumberFormatter(value)}
      prefix={<NumberOutlined spin={loading} />}
    />
  </Card>

const AdTrackerStatistics = ({
  adsWtdTitle,
  adsWtdLoading,
  adsWtdValue,
  adsLwtdTitle,
  adsLwtdLoading,
  adsLwtdValue,
  adsMtdTitle,
  adsMtdLoading,
  adsMtdValue,
  adsLmtdTitle,
  adsLmtdLoading,
  adsLmtdValue,
}: AdTrackerStatisticsProps): ReactElement => (
  <Row>
    <Col span={12}>
      <StatisticCard title={adsWtdTitle} loading={adsWtdLoading} value={adsWtdValue}/>
    </Col>
    <Col span={12}>
      <StatisticCard title={adsLwtdTitle} loading={adsLwtdLoading} value={adsLwtdValue}/>
    </Col>
    <Col span={12}>
      <StatisticCard title={adsMtdTitle} loading={adsMtdLoading} value={adsMtdValue}/>
    </Col>
    <Col span={12}>
      <StatisticCard title={adsLmtdTitle} loading={adsLmtdLoading} value={adsLmtdValue}/>
    </Col>
  </Row>
);

export default AdTrackerStatistics;
